export default __webpack_public_path__ + "static/media/4.a15c21ee.mp4";